import orderStyles from "@crm/styles/order.module.css";
import React from "react";
import {housekeeprApi} from "@crm/api/housekeepr-api";
import {skipToken} from "@reduxjs/toolkit/query";
import {
    selectWindowCleaningMaxPage,
    selectWindowCleaningServiceId,
    selectWindowCleaningWindows
} from "@crm/services/window-cleaning-selectors";
import {useAppDispatch, useAppSelector} from "@crm/services/store";
import {windowCleaningActions, WindowCleaningPage} from "@crm/services/window-cleaning-slice";
import {smoothScrollToTop} from "@crm/utils/helpers";

type WindowCleaningHomeCardProps = { hidden?: boolean };

export const WindowCleaningWindowsCard = (props: WindowCleaningHomeCardProps) => {
    const dispatch = useAppDispatch();

    const maxPage = useAppSelector(selectWindowCleaningMaxPage);

    const selectedServiceId = useAppSelector(selectWindowCleaningServiceId);
    const selectedWindows = useAppSelector(selectWindowCleaningWindows);

    const {
        data: windowTypesResult,
        isLoading: windowTypesLoading,
    } = housekeeprApi.useGetWindowTypesQuery(selectedServiceId ?? skipToken);

    return <div className={props.hidden ? orderStyles.hidden : orderStyles.cardWrapper}>
        <div className={orderStyles.card}>
            <div className={orderStyles.orderSection}>
                <h1 className={`${orderStyles.cardH1}`}>
                    Vælg vinduer og døre
                </h1>
                <p className={`${orderStyles.orderSectionContent} ${orderStyles.removeTopMargin}`}>
                    Hvis du ikke kan finde en præcis vinduestype, kan du blot vælge den type, der er er tættest
                    på.
                </p>
                <div
                    id={'window-types-content'}
                    className={`${orderStyles.orderSectionContent} ${orderStyles.flexRow} ${orderStyles.flexWrap} ${orderStyles.flexCrossStart}`}>
                    {windowTypesLoading && [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23].map((i) =>
                        <div
                            className={`${orderStyles.windowOption} ${orderStyles.shimmer}`}
                            key={i}
                        />
                    )}
                    {windowTypesResult?.map(windowType => {
                        return (
                            <div
                                className={`${orderStyles.windowOption} ${selectedWindows.some(selectedWindowType => selectedWindowType.id == windowType.id) ? orderStyles.selected : ''}`}
                                key={windowType.id}
                                id={`window-${windowType.id}`}
                            >
                                {/* eslint-disable-next-line @next/next/no-img-element */}
                                <img src={windowType.image_url} alt={windowType.description}
                                     className={orderStyles.windowImage}/>
                                <div className={'flex flex-grow-8'}></div>
                                <div className={orderStyles.windowName}>
                                    {windowType.name}
                                </div>
                                <div className={orderStyles.windowOptionFooter}>
                                    <div className={orderStyles.windowOptionButton} onClick={() => {
                                        const windowOption = document.getElementById(`window-${windowType.id}`);
                                        const windowCountInput = windowOption?.querySelector('input');
                                        if (!windowCountInput) return;
                                        const value = windowCountInput.value;
                                        const count = parseInt(value);
                                        const newValue = Math.max(0, isNaN(count) ? 0 : count - 1);
                                        windowCountInput.value = newValue <= 0 ? '' : newValue.toString();
                                        dispatch(windowCleaningActions.setWindowType({
                                            id: windowType.id,
                                            count: newValue
                                        }));
                                    }}>
                                        −
                                    </div>
                                    <input maxLength={2} placeholder={'0'}
                                           value={selectedWindows.find(window => window.id == windowType.id)?.count.toString()}
                                           onInput={event => {
                                               const windowCountInput = event.target as HTMLInputElement;
                                               const value = windowCountInput.value;
                                               const count = parseInt(value);
                                               const newValue = Math.max(0, Math.min(99, isNaN(count) ? 0 : count));
                                               windowCountInput.value = newValue <= 0 ? '' : newValue.toString();
                                               dispatch(windowCleaningActions.setWindowType({
                                                   id: windowType.id,
                                                   count: newValue
                                               }));
                                           }}/>
                                    <div className={orderStyles.windowOptionButton} onClick={() => {
                                        const windowOption = document.getElementById(`window-${windowType.id}`);
                                        const windowCountInput = windowOption?.querySelector('input');
                                        if (!windowCountInput) return;
                                        const value = windowCountInput.value;
                                        const count = parseInt(value);
                                        const newValue = Math.min(99, isNaN(count) ? 1 : count + 1);
                                        windowCountInput.value = newValue.toString();
                                        dispatch(windowCleaningActions.setWindowType({
                                            id: windowType.id,
                                            count: newValue
                                        }));
                                    }}>
                                        +
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
        <div className={`${orderStyles.flexRow} ${orderStyles.flexMainSpaceBetween} self-stretch`}>
            <div
                className={`${orderStyles.buttonWrapper} ${orderStyles.outline} w-[200px]`}>
                <button
                    onClick={() => {
                        dispatch(windowCleaningActions.setPage(WindowCleaningPage.HOME));
                        smoothScrollToTop();
                    }}
                >
                    Tilbage
                </button>
            </div>
            <div
                className={`${orderStyles.buttonWrapper} ${orderStyles.outline} ${maxPage < WindowCleaningPage.TIME ? orderStyles.disabled : ''} w-[200px]`}>
                <button
                    onClick={() => {
                        dispatch(windowCleaningActions.setPage(WindowCleaningPage.TIME));
                        smoothScrollToTop();
                    }}
                    disabled={maxPage < WindowCleaningPage.TIME}
                >
                    Videre
                </button>
            </div>
        </div>
    </div>
}

export default WindowCleaningWindowsCard;